import type {ConversationState} from './reducer.ts'
import type {V9Facts} from './v9-runtime.ts'

/** Retire only compatibility obligations for the abandoned internal check. */
export function retireInternalCheckRequirements(state:ConversationState,previous:V9Facts['check']):void {
  const c=state.v9!,f=c.facts;
  if(previous!=='lead'||!['public','website'].includes(f.check??''))return;
  const retired=new Set<string>();
  for(const d of c.dependencies){
    const internal=d.detail==='No connected CRM for the requested internal lead check'||f.systemType==='other'&&Boolean(f.systemName)&&d.detail===f.systemName;
    if(d.kind==='compatibility'&&internal){d.open=false;retired.add(d.id);c.superseded[d.id]='Buyer selected public checks; the abandoned internal CRM check is no longer requested.'}
  }
  const keep=(fr:{card:string;dependency:string|null;key:string})=>{if(fr.card==='F18'&&fr.dependency&&retired.has(fr.dependency)){c.superseded[fr.key]='The internal CRM compatibility review was superseded by the explicitly selected public checks.';return false}return true};
  c.pendingConcerns=c.pendingConcerns.filter(keep);c.frames=c.frames.filter(keep);
}
